// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"89084eed","166":"cbb7357f","819":"92843065"}[chunkId] + ".css";
};